import React from 'react'
import { Header} from './subComponent'
import "./stylesheet/about.css"
import { Footer} from './body'


export const Button=(props)=>{
return(
  <a  id="abutton" href={props.link}>
    {props.title}
  </a>)

}
const About = () => {
  return (
    <>

    <div className="containerm">
    <Header/>
<div className="introduction">
<span className="greetings">
Hii, My Name is 
</span>
<span className="myName">Umang sahu</span>
<span className='specification'>Web developer || Frontend developer</span>
<span className='introText'>
I am an electrical engineer turned into a front-end developer. currently, I am in my final year at BIET Jhansi. I've good experience in coding and excellent experience in a language like Html, Css Javascript, and Libary like React.
during these Days I was worked on many side projects (to see my projects click here) </span>


<div className="button-sec">

  <Button link={""} title={"hello world"}/>
</div>
</div>



    <div className="footer">
    <Footer></Footer>
    
    </div>
    </div>

  
    
    </>
  )
}

export default About